const config = {
  screens: {
    Starp: {
      path: 'webapp',
      screens: {
        FilesTab: {
          path: 'media',
          screens: {
            Folder: {
              path: 'folder/:folderId',
              // exact:true
            },
            Auction: {
              path: 'auction/:auctionId',
              // exact:true
            },
            Files: {
              path: '/',
            },
          },
        },
        SettingsTab: {
          path: 'settings',
          screens: {
            Devices: {
              path: 'devices',
              // exact:true
            },
            Drive: {
              path: 'drive',
              // exact:true
            },
            Databases: {
              path: 'databases',
              // exact:true
            },
            Premium: {
              path: 'premium',
              // exact:true
            },
            Settings: {
              path: '/',
              // exact:true
            },
          },
        },
        ContactsTab: {
          path: 'contact',
          screens: {
            Chat: {
              path: 'chat/:chatId',
              // exact:true
            },
            Contacts: {
              path: '/',
              // exact:true
            },
            Folder: {
              path: 'folder/:folderId',
              // exact:true
            },
          },
        },
        EncoderTab: {
          path: 'encoder',
          screens: {
            EncoderProjects: {
              path: '/',
              // exact:true
            },
            EncoderProject: {
              path: 'project/:projectId',
              // exact:true
            },
            Folder: {
              path: 'folder/:folderId',
              // exact:true
            },
          },
        },
        EditorTab: {
          path: 'editor',
          screens: {
            EditorProjects: {
              path: '/',
              // exact:true
            },
            EditorProject: {
              path: 'project/:projectId',
              // exact:true
            },
            Folder: {
              path: 'folder/:folderId',
              // exact:true
            },
          },
        },
        ShopTab: {
          path: 'shop',
          screens: {
            Shops: {
              path: '/',
              // exact:true
            },
            Shop: {
              path: '/:shopId/:mnemonic',
              screens: {
                Categories: {
                  path: '/',
                  // exact:true
                },
                Product: {
                  path: '/product/:productId',
                  // exact:true
                },
                Folder: {
                  path: '/folder/:folderId',
                  // exact:true
                },
                WebEditor: {
                  path: '/webeditor',
                  // exact:true
                },
                ShopConfig: {
                  path: '/config',
                  // exact:true
                },
                Orders: {
                  path: '/orders',
                  // exact:true
                },
                Order: {
                  path: '/order/:orderId',
                  // exact:true
                },
                Payouts: {
                  path: '/payouts',
                  // exact:true
                },
              },
              // exact:true
            },
          },
        },
      },
    },
  },
};

export const linking = {
  prefixes: [
    'starpy://',
    'https://www.starpy.me',
    /* your linking prefixes */
  ],
  config,
};
